import { render, staticRenderFns } from "./FootView.vue?vue&type=template&id=5907bf67&scoped=true&"
import script from "./FootView.vue?vue&type=script&lang=ts&"
export * from "./FootView.vue?vue&type=script&lang=ts&"
import style0 from "./FootView.vue?vue&type=style&index=0&id=5907bf67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5907bf67",
  null
  
)

export default component.exports